function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B3DCFF",
  d: "M82.41 0C38.07 0 3.34 56.4.05 104c13.91 24.15 47.46 33.22 82.35 33.22 34.89 0 68.44-9.08 82.35-33.22C161.47 56.4 126.74 0 82.41 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5ECC62",
  d: "M133.73 59.22C124 46.67 111.59 33.39 104.4 33.39 97.21 33.39 77.1 69 67.87 69s-14-16.2-25.36-16.14c-15.45.09-30.6 45.52-30.6 45.52s6.26 27.77 71.79 27.77 70.76-27.31 70.76-27.31-6.74-21.58-20.73-39.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M47.29 94.49a8.3 8.3 0 1 1 16.6 0 8.3 8.3 0 0 1-16.6 0zm53.63 0a8.3 8.3 0 1 0 16.6 0 8.3 8.3 0 0 0-16.6 0zm-1.49 12.05a2.556 2.556 0 0 0-4.53-2.37c-.14.26-3.47 6.25-12.29 6.25a15.24 15.24 0 0 1-12.78-6.4 2.554 2.554 0 0 0-4.36 2.66 20.35 20.35 0 0 0 17.14 8.84c12.02.02 16.63-8.61 16.82-8.97v-.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00AD45",
  d: "M68.9 84.19c-10.18 0-15.39-10-18.22-16.24-2.55-5.58-3-14.4-10.2-14.64a5.61 5.61 0 0 1 2-.45C53.85 52.86 58.65 69 67.87 69c9.22 0 29.33-35.6 36.53-35.6a10.25 10.25 0 0 1 4.54 1.33 4.61 4.61 0 0 0-4 1.17C102.6 38.21 81.5 84.19 68.9 84.19z"
}));

var SvgBasecampIco = function SvgBasecampIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 138,
    viewBox: "0 0 165 138",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasecampIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basecamp_ico.6c0f7a41.svg";
export { ForwardRef as ReactComponent };